import React from 'react';

const TimeUnit = ({ value, label, isLast }) => {
  const paddedValue = value.toString().padStart(2, '0');

  return (
    <div className="flex items-center">
      <div className="flex flex-col items-center justify-center w-[60px] sm:w-[80px]">
        <span
          style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 700 }}
          className="text-[52px] sm:text-[68px] text-white leading-none tracking-wide"
        >
          {paddedValue}
        </span>
        <span
          style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 400 }}
          className="text-[10px] sm:text-[12px] text-white/80 mt-1 uppercase tracking-widest"
        >
          {label}
        </span>
      </div>

      {!isLast && (
        <div className="w-[1px] h-[45px] sm:h-[58px] bg-white/25 mx-3 sm:mx-5" />
      )}
    </div>
  );
};

export default TimeUnit;